import { PlusCircleFilled, ReloadOutlined } from "@ant-design/icons";
import {
  Card,
  Col,
  message,
  Row,
  Select,
  Form,
  Input,
  Button,
  Button as AntButton,
} from "antd";
import React from "react";
import { TypeIva } from "../../api/utils";
import { useProductStore } from "./LayoutProducto";
import { ContableItems } from "./ContableItems";
import { useAttributesStore } from "../Layouts/Atributes";
import { toast } from "react-toastify";

export const productStore = 1;
const { Option } = Select;

export const ProductSimple = ({ addProductSimple, reloadAttributes }) => {
  const producto = useProductStore();
  const attributes = useAttributesStore();
  const brands = Array.isArray(attributes.groups?.[1])
    ? attributes.groups[1]
    : [];

  const [reloading, setReloading] = React.useState(false);

  const handleReloadBrands = async () => {
    if (!reloadAttributes) return;

    setReloading(true);
    try {
      await reloadAttributes();
      toast.success("Marcas actualizadas correctamente");
    } catch (error) {
      toast.error("Error al actualizar marcas");
    } finally {
      setReloading(false);
    }
  };

  const onFinish = (values) => {
    console.log("::values", values);
    producto.setData({ productstore: productStore });
    addProductSimple(productStore);
  };

  const onFinishFailed = (errorInfo) => {
    message.info("Por favor complete todos los campos");
  };

  return (
    <Row justify="center" className="product-form-layout" style={{ marginTop: "5px" }}>
      <Col span={24} className="site-card-border-less-wrapper product-form-column">
          <Card
            className="product-form-card"
            hoverable
            bordered
            title="Detalles del producto"
            style={{
              borderRadius: "12px",
              margin: 5,
            }}
          >
            <Form
              className="product-form"
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              initialValues={{
                Codigo: producto.data.Codigo,
                IdCategoria: producto.data.IdCategoria,
                IdSubCategoria: producto.data.IdSubCategoria,
                webCategoryIds: producto.data.webCategoryIds,
                IdMarca: producto.data.IdMarca,
                Descripcion: producto.data.Descripcion,
                PrecioVentaConIva1: producto.data.PrecioVentaConIva1,
                PrecioVentaConIva2: producto.data.PrecioVentaConIva2,
                PrecioVentaConIva3: producto.data.PrecioVentaConIva3,
                PorcentajeIva: producto.data.PorcentajeIva,
                cat0: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 0,
                )?.NumeroCuenta,
                cat1: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 1,
                )?.NumeroCuenta,
                cat2: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 2,
                )?.NumeroCuenta,
                cat3: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 4,
                )?.NumeroCuenta,
                cat4: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 5,
                )?.NumeroCuenta,
                weight: producto.data.weight,
                height: producto.data.height,
                width: producto.data.width,
                large: producto.data.large,
              }}
            >
              <div className="product-form-section" style={{ marginBottom: "32px" }}>
                <h3
                  className="product-form-section-title"
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "16px",
                    color: "#555",
                  }}
                >
                  Información Básica
                </h3>
                <Row
                  gutter={[24, 16]}
                  style={{
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    rowGap: "0px",
                  }}
                >
                  <Col xs={24} lg={24}>
                    <Form.Item
                      label={
                        <span style={{ fontWeight: 700, color: "#cf1322" }}>
                          Código de Referencia *
                        </span>
                      }
                      name="Codigo"
                      rules={[
                        {
                          required: true,
                          message: "El código de referencia es obligatorio.",
                        },
                        {
                          max: 16,
                          message:
                            "No puedes agregar más caracteres para que no se corte el nombre en la impresión del sticker.",
                        },
                      ]}
                      tooltip="Este código es el que va impreso en el sticker. Debe ser corto (máximo 16 caracteres) para que no se corte."
                      extra={
                        (producto?.data?.Codigo?.length || 0) >= 16
                          ? "No puedes agregar más caracteres para que no se corte el nombre en la impresión del sticker."
                          : "Este código se imprime en el sticker. Usa un máximo de 16 caracteres."
                      }
                      required
                    >
                      <Input
                        value={producto?.data?.Codigo || ""}
                        placeholder="Código corto para impresión del sticker"
                        maxLength={16}
                        showCount
                        onChange={(e) =>
                          producto.setData({ Codigo: e.target.value })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={24}>
                    <Form.Item
                      label="Nombre del Producto"
                      name="Descripcion"
                      rules={[
                        {
                          required: true,
                          message: "Digite el nombre del producto",
                        },
                      ]}
                      tooltip="Nombre descriptivo del producto"
                    >
                      <Input
                        placeholder="Ej: Camiseta de Algodón"
                        onChange={(value) =>
                          producto.setData({ Descripcion: value.target.value })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      name="IdCategoria"
                      label="Categoría ARI"
                      rules={[
                        { required: true, message: "Selecciona una Categoría ARI" },
                      ]}
                      tooltip="Selecciona la Categoría ARI principal del producto"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({
                            IdCategoria: value,
                            Categoria: producto.knowName(
                              value,
                              producto.categorys,
                            ),
                          })
                        }
                        placeholder="Selecciona una Categoría ARI"
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                      >
                        {producto.categorys.map((category) => (
                          <Option key={category.id} value={category.id}>
                            {category.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      name="IdSubCategoria"
                      label="SubCategoría ARI"
                      rules={[
                        {
                          required: true,
                          message: "Selecciona una subCategoría ARI",
                        },
                      ]}
                      tooltip="Selecciona una subCategoría ARI"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({
                            IdSubCategoria: value,
                            SubCategoria: producto.knowName(
                              value,
                              producto.categorys,
                            ),
                          })
                        }
                        placeholder="Selecciona una subCategoría ARI"
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                      >
                        {producto.categorys.map((category) => (
                          <Option key={category.id} value={category.id}>
                            {category.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <span>Marca</span>
                          <AntButton
                            icon={<ReloadOutlined />}
                            onClick={handleReloadBrands}
                            loading={reloading}
                            size="small"
                            type="link"
                            style={{ marginLeft: "8px" }}
                          >
                            Actualizar
                          </AntButton>
                        </div>
                      }
                      name="IdMarca"
                      tooltip="Selecciona una marca (opcional)"
                    >
                      <Select
                        placeholder="Selecciona una marca"
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(value) => {
                          if (!value) {
                            producto.setData({
                              IdMarca: null,
                              Marca: null,
                              tags: [],
                            });
                            return;
                          }

                          const selectedBrand = brands.find(
                            (b) => b.id === value,
                          );

                          producto.setData({
                            IdMarca: value,
                            Marca: selectedBrand?.name || null,
                            tags: selectedBrand?.name
                              ? [selectedBrand.name]
                              : [],
                          });
                        }}
                        notFoundContent={
                          brands.length === 0
                            ? "No hay marcas disponibles. Haz clic en 'Actualizar'"
                            : "No se encontraron marcas"
                        }
                      >
                        {brands.map((brand) => (
                          <Option key={brand.id} value={brand.id}>
                            {brand.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={24}>
                    <Form.Item
                      name="webCategoryIds"
                      label="Categorías adicionales Página Web"
                      tooltip="Estas categorías se enviarán solo a la página web y no afectarán la categoría principal de ARI."
                      extra="Puedes seleccionar una o varias categorías adicionales para mostrar este producto en más secciones de la web."
                    >
                      <Select
                        mode="multiple"
                        placeholder="Selecciona categorías adicionales para la web"
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        onChange={(value) =>
                          producto.setData({
                            webCategoryIds: value || [],
                          })
                        }
                      >
                        {producto.categorys.map((category) => (
                          <Option key={category.id} value={category.id}>
                            {category.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div className="product-form-section" style={{ marginBottom: "32px" }}>
                <h3
                  className="product-form-section-title"
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "16px",
                    color: "#555",
                  }}
                >
                  Detalles Contables
                </h3>
                <div
                  className="product-form-note"
                  style={{
                    background: "#FFFADA",
                    padding: "10px",
                    borderRadius: "10px",
                    fontSize: "12px",
                  }}
                >
                  <p>
                    <strong>Códigos contables por Categoría ARI:</strong>
                  </p>
                  <ul>
                    <li>
                      <strong>ACCESORIOS Y TETEROS</strong> → 14351501,
                      41351501, 61351501, 41750501, 62259501
                    </li>
                    <li>
                      <strong>ASEO Y PAÑALES</strong> → 14351401, 41351401,
                      61351401, 41750501, 61351401
                    </li>
                    <li>
                      <strong>COCHES, CAMINADORES Y BASENILLAS</strong> →
                      14351601, 41351601, 61351601, 41750501, 62259501
                    </li>
                    <li>
                      <strong>TEXTIL</strong> → 14351301, 41351301, 61351301,
                      41750501, 62259501
                    </li>
                  </ul>
                </div>
                <ContableItems />
              </div>

              <div className="product-form-section" style={{ marginBottom: "32px" }}>
                <h3
                  className="product-form-section-title"
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "16px",
                    color: "#555",
                  }}
                >
                  Precios y Peso
                </h3>
                <Row
                  gutter={[24, 16]}
                  style={{
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    rowGap: "0px",
                  }}
                >
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Precio de venta Mostrador"
                      name="PrecioVentaConIva1"
                      rules={[
                        {
                          required: true,
                          message: "Digite el precio de venta mostrador",
                        },
                      ]}
                      tooltip="Precio de venta mostrador (incluye IVA)"
                    >
                      <Input
                        placeholder="$200.000"
                        type="number"
                        onChange={(value) =>
                          producto.setData({
                            PrecioVentaConIva1: parseInt(value.target.value),
                          })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Precio de venta Minorista"
                      name="PrecioVentaConIva2"
                      rules={[
                        {
                          required: true,
                          message: "Digite el precio de venta minorista",
                        },
                      ]}
                      tooltip="Precio de venta minorista (incluye IVA)"
                    >
                      <Input
                        placeholder="$160.000"
                        type="number"
                        onChange={(value) =>
                          producto.setData({
                            PrecioVentaConIva2: parseInt(value.target.value),
                          })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Precio de venta Mayorista"
                      name="PrecioVentaConIva3"
                      rules={[
                        {
                          required: true,
                          message: "Digite el precio de venta Mayorista",
                        },
                      ]}
                      tooltip="Precio de venta Mayorista (incluye IVA)"
                    >
                      <Input
                        placeholder="$120.000"
                        type="number"
                        onChange={(value) =>
                          producto.setData({
                            PrecioVentaConIva3: parseInt(value.target.value),
                          })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Peso del producto"
                      name="weight"
                      rules={[
                        {
                          required: true,
                          message: "Digite el peso del producto",
                        },
                      ]}
                      tooltip="Peso del producto (ej: 1 kg, 0.3 kg)"
                    >
                      <Input
                        placeholder="(1): kg | (0.3): otros"
                        type="text"
                        onChange={(value) =>
                          producto.setData({ weight: value.target.value })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={8}>
                    <Form.Item
                      label="Largo (cm)"
                      name="length"
                      rules={[{ required: true, message: "Digite el largo" }]}
                      tooltip="Largo del producto en centímetros"
                    >
                      <Input
                        placeholder="Ej: 10"
                        type="number"
                        onChange={(e) =>
                          producto.setData({
                            dimensions: {
                              ...producto.data.dimensions,
                              length: e.target.value,
                            },
                          })
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={8}>
                    <Form.Item
                      label="Ancho (cm)"
                      name="width"
                      rules={[{ required: true, message: "Digite el ancho" }]}
                      tooltip="Ancho del producto en centímetros"
                    >
                      <Input
                        placeholder="Ej: 5"
                        type="number"
                        onChange={(e) =>
                          producto.setData({
                            dimensions: {
                              ...producto.data.dimensions,
                              width: e.target.value,
                            },
                          })
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={8}>
                    <Form.Item
                      label="Alto (cm)"
                      name="height"
                      rules={[{ required: true, message: "Digite el alto" }]}
                      tooltip="Alto del producto en centímetros"
                    >
                      <Input
                        placeholder="Ej: 2"
                        type="number"
                        onChange={(e) =>
                          producto.setData({
                            dimensions: {
                              ...producto.data.dimensions,
                              height: e.target.value,
                            },
                          })
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div className="product-form-section" style={{ marginBottom: "32px" }}>
                <h3
                  className="product-form-section-title"
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "16px",
                    color: "#555",
                  }}
                >
                  Impuestos
                </h3>
                <Row
                  gutter={[24, 16]}
                  style={{
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    rowGap: "0px",
                  }}
                  justify="start"
                >
                  <Col xs={24} lg={12}>
                    <Form.Item
                      name="PorcentajeIva"
                      label="Porcentaje IVA"
                      rules={[
                        {
                          required: true,
                          message: "Selecciona un porcentaje IVA",
                        },
                      ]}
                      tooltip="Selecciona el porcentaje de IVA aplicable"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({ PorcentajeIva: value })
                        }
                        placeholder="Selecciona un porcentaje IVA"
                        allowClear
                        style={{ width: "100%" }}
                      >
                        {TypeIva.map((typeiva) => (
                          <Option key={typeiva.Codigo} value={typeiva.Valor}>
                            {typeiva.Descripcion}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <Form.Item
                className="product-form-submit"
                style={{ textAlign: "center", marginTop: "24px" }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  shape="round"
                  size="large"
                  icon={<PlusCircleFilled />}
                  className="product-form-primary-button"
                  style={{
                    padding: "0 32px",
                    height: "48px",
                    fontSize: "16px",
                    fontWeight: 500,
                    borderRadius: "10px",
                    transition: "all 0.3s ease",
                  }}
                >
                  Crear Producto
                </Button>
              </Form.Item>
            </Form>
          </Card>
      </Col>
    </Row>
  );
};
